import styles from './contact.module.css';

const Contact = () => {
    return (
        <div className={styles.contactContainer}>
            <p>sukkla@sukkla.fo</p>
        </div>
    );
};

export default Contact;
